
(function () {
    var window_width = null;
    
    $(window).on("load", function () {
        let btnShowTablebtnShowTable = "";
    
        btnShowTablebtnShowTable = document.querySelector("button[data-show='show']");
    
        if(btnShowTablebtnShowTable) {
            $(document.querySelector("button[data-show='show']")).click(function() {
                let btnShowHide = document.querySelector("button[data-show='show']");
        
                if (btnShowHide.ariaExpanded === 'true') {
                    btnShowHide.ariaExpanded = 'false';
                    $(document.querySelector("div[data-show='content']")).slideUp("slow");
        
                    btnShowHide.innerText = 'VER MÁS';
        
                } else {
                    btnShowHide.ariaExpanded = 'true';
                    $(document.querySelector("div[data-show='content']")).slideDown("slow");
                    btnShowHide.innerText = 'VER MENOS';
                }
            });
    
        }
    });

    function widthActual() {
        window_width = window.innerWidth;
    }

    this.addEventListener("resize", (event) => {
        widthActual();
    });
})($)
